/*
 * @Author: Huangxianlong
 * @Date: 2023-05-29 10:27:17
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2024-10-22 15:57:44
 * @FilePath: \monitor\src\router\index.js
 * @Description: 
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Cookies from 'js-cookie';
import { routers } from './router';
import Tools from '../libs/tools';

Vue.use(VueRouter);
// 解决vue-router在3.0版本以上重复点报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
// 路由配置
const RouterConfig = {
  mode: 'hash',
  routes: routers
};

export const router = new VueRouter(RouterConfig);

// 方案4: 路由守卫优化
// 白名单路径（不需要登录即可访问）
const WHITE_LIST = ['login', 'register', 'forgetpwd', 'error-404', 'error-403', 'error-500'];

// 缓存登录状态，避免每次路由切换都检查
let cachedLoginStatus = null;

router.beforeEach((to, from, next) => {
  // 如果是白名单路径，直接放行
  if (WHITE_LIST.includes(to.name)) {
    // 如果已登录但访问登录页，跳转到首页
    if (to.name === 'login' && isLoggedIn()) {
      next({ name: 'home' });
    } else {
      next();
    }
    return;
  }
  
  // 检查登录状态
  if (!isLoggedIn()) {
    next({ name: 'login' });
    return;
  }
  
  next();
});

// 检查登录状态的辅助函数
function isLoggedIn() {
  const cookieKey = serverConfig.language == "EN" ? "user-en" : "user-cn";
  const cookieExists = Cookies.get(cookieKey);
  const loginInfoExists = Tools.methods.StorageGet("loginInfo");
  return !!(cookieExists && loginInfoExists);
}

// 登录成功后调用此方法更新缓存
export function updateLoginStatus() {
  cachedLoginStatus = isLoggedIn();
}

router.afterEach((to) => {
  Tools.methods.StorageSet({
    key: "currentpage",
    val: to.name
  });
});

// 方案6: 预加载首页所需的资源
router.afterEach((to) => {
  if (to.name === 'home') {
    // 预加载其他重量级路由组件
    const preloadRoutes = [
      () => import('@/view/report/vm2030Report.vue'),
      () => import('@/view/report/report.vue'),
      () => import('@/view/realtimechart/index.vue'),
    ];
    preloadRoutes.forEach(route => {
      route().catch(() => {}); // 静默失败
    });
  }
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js